import React, { useEffect, useState } from 'react';
import CustomCheckbox from '../../../components/CustomCheckbox';
import Select from 'react-select';
import { useNavigate } from 'react-router';
import DataTDs from './DataTDs';

function SumDataTbodyRow({
    index, item,
    chkedData, setChkedData,
    sumDs, isVacant = false
}) {
    const navigate = useNavigate();


    const dataDecisionOpt = [
        { label: "OK", value: "OK" },
        { label: "NG", value: "NG" },
    ];

    const onClickMaterialDetail = e => {
        e.preventDefault();
        navigate(`/home/data/monitoring?name=material&dataId=${item.materialId}`);
    };
    const onClickLoadDetail = e => {
        e.preventDefault();
        navigate(`/home/data/monitoring?name=load&dataId=${item.loadId}`);
    };
    const onClickSizeDetail = e => {
        e.preventDefault();
        navigate(`/home/data/monitoring?name=size&dataId=${item.sizeId}`);
    };

    let timeStr = '';

    if (!!item?.time) {
        const time = new Date(item.time);
        const dataH = time.getHours();
        const dataM = time.getMinutes();
        const dataS = time.getSeconds();
        const fullYear = time.getFullYear();
        const month = parseInt(time.getMonth()) + 1 < 10 ? `0${parseInt(time.getMonth()) + 1}` : time.getMonth() + 1;
        const date = parseInt(time.getDate()) < 10 ? `0${parseInt(time.getDate())}` : time.getDate();
        const timeH = parseInt(dataH) < 10 ? `0${parseInt(dataH)}` : dataH;
        const timeM = parseInt(dataM) < 10 ? `0${parseInt(dataM)}` : dataM;
        const timeS = parseInt(dataS) < 10 ? `0${parseInt(dataS)}` : dataS;
        timeStr = `${fullYear}-${month}-${date} ${timeH}:${timeM}:${timeS}`;
    }
    function getDecision(sumDs, data) {
        const { grpNo } = sumDs;
        const decisions = [];
        for (let grpIdx = 0; grpIdx < grpNo; grpIdx++) {
            const value = data[`sDecision_${grpIdx}`];
            if (value !== null && value !== undefined) {
                decisions.push(value);
            }
        }
        if (decisions.length === 0) return '-';
        return decisions.some(value => value === 'NG') ? 'NG' : 'OK';
    }
    return (
        <tr key={index}>
            <td className='dataChkbox'>
                {
                    isVacant ?
                        null :
                        <CustomCheckbox
                            id={`checkbox_${index}`}
                            checked={chkedData.includes(`${item.dataId}`)}
                            onChange={e => {
                                if (e.target.checked) {
                                    setChkedData([...chkedData, e.target.value]);
                                } else {
                                    setChkedData(chkedData.filter(el => el !== e.target.value));
                                };
                            }}
                            value={item.dataId}
                        />
                }
            </td>
            <td className='dataTime'>
                {
                    isVacant ?
                        null :
                        <p>{timeStr}</p>
                }
            </td>
            <td className='dataDecision'>
                {
                    isVacant ?
                        null :
                        // <Select
                        //     options={dataDecisionOpt}
                        //     value={dataDecisionOpt.find(el => el.value === item.decision)}
                        //     // onChange={sel => onChangeValue(index, 'decision', sel.value)}
                        //     isSearchable={false}
                        //     classNames={{
                        //         control: (state) => 'control',
                        //         container: (state) => 'selectBox',
                        //         dropdownIndicator: (state) => 'arrow',
                        //         menu: (state) => 'options',
                        //         option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                        //         singleValue: (state) => 'singleVal',
                        //         valueContainer: (state) => 'valueContainer',
                        //     }}
                        //     components={{
                        //         DropdownIndicator: (state) => null,
                        //         IndicatorSeparator: (state) => null,
                        //     }}
                        //     openMenuOnClick={false}
                        // />
                        <p>{getDecision(sumDs, item)}</p>
                }
            </td>
            <td className='dataModelType'>
                {
                    isVacant ?
                        null :
                        <React.Fragment>
                            <p>{item.model.modelType}</p>
                            <div className='hintArea'>
                                <span className='hintSpan'>{item.model.modelType}</span>
                            </div>
                        </React.Fragment>
                }
            </td>
            <td className='dataModelName'>
                {
                    isVacant ?
                        null :
                        <React.Fragment>
                            <p>{item.model.modelName}</p>
                            <div className='hintArea'>
                                <span className='hintSpan'>{item.model.modelName}</span>
                            </div>
                        </React.Fragment>
                }
            </td>
            <td className='dataModelNo'>
                {
                    isVacant ?
                        null :
                        <React.Fragment>
                            <p>{item.model.modelNo}</p>
                            <div className='hintArea'>
                                <span className='hintSpan'>{item.model.modelNo}</span>
                            </div>
                        </React.Fragment>
                }
            </td>
            <td className='dataCount'>
                {
                    isVacant ?
                        null :
                        <p>{item.count}</p>
                }
            </td>
            <DataTDs
                sumDs={sumDs}
                data={item}
                isVacant={isVacant}
            />

            <td className='dataNgFactor'>
                {
                    isVacant ?
                        null :
                        <p>{item.ngFactor ?? '없음'}</p>
                }
            </td>
            <td className='dataComment'>
                {
                    isVacant ?
                        null :
                        <p>{item.comment}</p>
                }
            </td>
            <td className='dataDetail'>
                {
                    isVacant ?
                        null :
                        <button className='detailBtn' onClick={e => {
                            e.preventDefault();
                            navigate(`/home/data/sumData/detail?sumDsId=${sumDs.sumDsId}&dataId=${item.dataId}`)
                        }}
                        // disabled={userIsNormal}
                        >상세</button>
                }
            </td>
        </tr>
    );
}

export default SumDataTbodyRow;
